import { useEffect, useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import bannerConfig from '../config/banners.json';

interface Banner {
  title: string;
  description: string;
  link: string;
  type: string[];
  language: string[];
  imageKey: string;
  size: string;
}

type BannerConfig = {
  banners: {
    [key: string]: Banner;
  };
};

export const useBanners = (pageType: string) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [relevantBanners, setRelevantBanners] = useState<Banner[]>([]);

  useEffect(() => {
    const currentSize = isDesktop ? 'desktop' : 'mobile';

    const config = bannerConfig as BannerConfig;
    const filteredBanners = Object.values(config.banners).filter((banner) => {
      return (
        banner.type.includes(pageType) &&
        banner.size === currentSize
      );
    });

    setRelevantBanners(filteredBanners);
  }, [pageType, isDesktop]);

  return relevantBanners;
}; 